import {Pipe, PipeTransform} from '@angular/core';
import {PersonalExpenseSimpleDto} from '../../Models/Documents-review/personal-expense-simple';

@Pipe({
  name: 'personalExpenses',
  standalone: false
})
export class PersonalExpensesPipe implements PipeTransform {

  transform(items: PersonalExpenseSimpleDto[], filter: { review?: boolean }): PersonalExpenseSimpleDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.review) {
      items = items.filter((item) => item.pendiente_ocr || item.error_ocr);
    }

    return items;

  }

}
